export default __webpack_public_path__ + "static/media/screen3.0f011358.png";